import React from 'react';
import { NewInfoIcon } from '../Icons';
import * as Ui from './styles';

function TooltipInfo({
  /**
   * info text
   */
  toolTipText = null,
  /**
   * others props
   */
  ...props
}) {
  // from theme or parent style
  const { className, theme } = props;

  /**
   * render info badge
   */
  function renderIcon() {
    return (<NewInfoIcon size={16} theme={theme} />);
  }

  return (
    <Ui.Container className={className} theme={theme} iconColor={props.iconColor}>
      {toolTipText ? (
        <Ui.TooltipWrapper>
          {renderIcon()}
          <Ui.TooltipText>{toolTipText}</Ui.TooltipText>
        </Ui.TooltipWrapper>
      ) : renderIcon()}
    </Ui.Container>
  );
}

export { TooltipInfo };
export default TooltipInfo;
